import React from "react";
import { Field } from "formik";
import styles from "./Input.module.scss";
import _ from "lodash";
import cx from "classnames";
const View = ({
  name,
  validate,
  fast,
  placeholder,
  onChange,
  required,
  onBlur,
  theme = "light",
}: any) => {
  const ref: any = React.useRef({});
  const onChangeHandle = (event: any) => {
    const value = _.get(event, "target.value");

    ref.current.form && ref.current.form.setFieldValue(name, value);
    onChange && onChange(value);
  };
  const onBlurHandle = (e: any) => {
    ref.current.form && ref.current.form.setFieldTouched(name);
    onBlur && onBlur(e);
  };
  return (
    <Field name={name} validate={validate} fast={fast}>
      {({ field: { value }, form, meta }: any) => {
        ref.current.form = form;
        return (
          <div
            className={cx(styles.group, {
              [styles.valid]: !!value,
            })}
          >
            <textarea
              value={value}
              className={cx({ [styles.dark]: theme === "dark" })}
              onChange={onChangeHandle}
              onBlur={onBlurHandle}
            />
            <span className={styles.highlight} />
            <span className={styles.bar} />
            <label className={cx({ [styles.dark]: theme === "dark" })}>
              {placeholder}
              {required && <span className={styles.required}>*</span>}
            </label>
            {meta.touched && meta.error && (
              <div className={styles.error}>{meta.error}</div>
            )}
          </div>
        );
      }}
    </Field>
  );
};
export default View;
